var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTristarImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 308,
    height: 21,
    viewBox: "0 0 308 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2a72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39257",
    "data-name": "Group 39257",
    transform: "translate(-491.5 -3175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M10.5,0,21,10.5,10.5,21,0,10.5Z",
    transform: "translate(598 3175)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M10.5,0,21,10.5,10.5,21,0,10.5Z",
    transform: "translate(635 3175)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M10.5,0,21,10.5,10.5,21,0,10.5Z",
    transform: "translate(672 3175)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_470",
    "data-name": "Line 470",
    x1: 95,
    transform: "translate(491.5 3185.5)",
    fill: "none",
    stroke: "#feb546",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_471",
    "data-name": "Line 471",
    x1: 95,
    transform: "translate(704.5 3185.5)",
    fill: "none",
    stroke: "#feb546",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTristarImg);
export default __webpack_public_path__ + "static/media/tristar-img.dbf7a4f017d5d8b141d019e8a315f85b.svg";
export { ForwardRef as ReactComponent };